<md-tag class="status">
  <span>Account Issue</span>
</md-tag>

<div class="message">
  <div class="md-display-lg-semibold">Account Not Found...</div>
  <div class="md-text-md-regular">We couldn't locate a LanguageBird account linked to this sign in.</div>
  <div class="md-text-sm-regular subtle">Please confirm you are logging in with the correct account</div>

  @if (claims) {
    <div class="identity">
      <div class="md-text-sm-semibold heading">Identity details</div>
      <ul>
        @if (claims.email) {
          <li><strong>Email:</strong> {{ claims.email }}</li>
        }
        @if (claims.name) {
          <li><strong>Name:</strong> {{ claims.name }}</li>
        }
      </ul>
    </div>
  }

  <div class="actions">
    <button type="button" md-button (click)="logout()">Sign Out</button>
  </div>
</div>
